import { Box } from '@mui/material';
import { FC } from 'react';

interface IProps {}
export const FormLayout: FC<IProps> = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                py: 10,
                flexDirection: 'column'
            }}
        >
            <Box
                sx={{
                    width: 360,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
